<template>
  <div>
    <PageMain
      ref="main"
      :loading="loading"
      :tableData="tableData"
      @reload="getData()"
    />
  </div>
</template>
<script>
import PageMain from './main'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { PageMain },
  mixins: [EditLoading],
  props: { amzPurchaseBatchCode: { type: String, default: '' } },
  data() {
    return { tableData: [], loading: false }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzPurchaseBatchCode) return
      this.loading = true
      const params = { amzPurchaseBatchCode: this.amzPurchaseBatchCode }
      const res = await this.$api
        .ecomAmzFtyPurchaseBatchSkuListApi(params)
        .catch(() => null)
      this.loading = false
      this.tableData = res?.body?.data || []
    },
  },
}
</script>
